import { Pipe, PipeTransform } from '@angular/core';
import { NO_VALUE } from '@pipes';
import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateHeatingSolarStatus',
})
export class TranslateHeatingSolarStatusPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string | undefined): string {
    if (!value) {
      return NO_VALUE;
    }

    if (this.customTranslationsService.HEATING_SOLAR_STATUS[value]) {
      return this.translateService.instant(
        this.customTranslationsService.HEATING_SOLAR_STATUS[value] ?? value
      );
    }

    return value;
  }
}
